export default __webpack_public_path__ + "static/media/logo-negro-320.11a7c753.png";